import { render, staticRenderFns } from "./personnelInfo.vue?vue&type=template&id=ed4695ea&scoped=true&"
import script from "./personnelInfo.vue?vue&type=script&lang=js&"
export * from "./personnelInfo.vue?vue&type=script&lang=js&"
import style0 from "./personnelInfo.vue?vue&type=style&index=0&id=ed4695ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4695ea",
  null
  
)

export default component.exports